// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-launches {
    background: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.section-tabs {
    display: flex;
    gap: 5px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
}

.section-tabs .tab {
    padding: 10px 20px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    transition: all 0.3s ease;
}

.section-tabs .tab.active {
    color: #007bff;
    border-bottom-color: #007bff;
}

.section-tabs .tab:hover:not(.active) {
    color: #333;
    background-color: #f8f9fa;
}

.launches-content {
    padding-top: 20px;
}

.launches-grid {
    height: 400px;
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

.launches-chart h3,
.launches-summary h3 {
    font-size: 1.2rem;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
}
.launches-chart,
.launches-summary {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.chart-container {
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.launches-summary {
    overflow-y: auto;
}

.summary-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    overflow-y: auto;
}

.summary-table th,
.summary-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}
.summary-table thead,
.summary-table tfoot {
    position: sticky;
    background: #f8f9fa;
}

.summary-table thead {
    top: 0;
}

.summary-table tfoot {
    bottom: 0;
}
.summary-table tbody {
    display: block;
    max-height: 220px; /* adjust to desired viewport space */
    overflow-y: auto;
}
.summary-table thead,
.summary-table tfoot,
.summary-table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}
.summary-table tbody {
    width: 100%;
}

.summary-table th,
.summary-table td {
    box-sizing: border-box;
}
.summary-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    color: #333;
}

.summary-table .total-row {
    background-color: #e3f2fd;
    font-weight: 500;
}

.brand-content {
    padding: 40px;
    text-align: center;
    color: #666;
}

.custom-tooltip {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 10px;
    font-size: 12px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tooltip-label {
    font-weight: 600;
    margin-bottom: 5px;
    color: #333;
}

@media (max-width: 1024px) {
    .launches-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .app-launches {
        padding: 15px;
    }

    .section-tabs {
        flex-wrap: wrap;
    }

    .chart-container {
        height: 250px;
    }
}

.average-stats{
    border-radius: 8px;
    overflow-y: auto;
    max-height: 460px;
}
.average-length{
    max-height:  375px !important;
}
.customer-header{
    background-color: #f8f9fa;
    font-weight: 600;
    color: #333;
    padding: 5px;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/css/Downloads.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;IAEI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;AACA;;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;AACA;IACI,cAAc;IACd,iBAAiB,EAAE,qCAAqC;IACxD,gBAAgB;AACpB;AACA;;;IAGI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;;AAEA;;IAEI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".app-launches {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.section-tabs {\r\n    display: flex;\r\n    gap: 5px;\r\n    margin-bottom: 20px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.section-tabs .tab {\r\n    padding: 10px 20px;\r\n    background: none;\r\n    border: none;\r\n    border-bottom: 2px solid transparent;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    color: #666;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.section-tabs .tab.active {\r\n    color: #007bff;\r\n    border-bottom-color: #007bff;\r\n}\r\n\r\n.section-tabs .tab:hover:not(.active) {\r\n    color: #333;\r\n    background-color: #f8f9fa;\r\n}\r\n\r\n.launches-content {\r\n    padding-top: 20px;\r\n}\r\n\r\n.launches-grid {\r\n    height: 400px;\r\n    display: flex;\r\n    gap: 30px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.launches-chart h3,\r\n.launches-summary h3 {\r\n    font-size: 1.2rem;\r\n    color: #333;\r\n    margin: 0 0 20px 0;\r\n    font-weight: 600;\r\n}\r\n.launches-chart,\r\n.launches-summary {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.chart-container {\r\n    height: 300px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.launches-summary {\r\n    overflow-y: auto;\r\n}\r\n\r\n.summary-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    font-size: 14px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.summary-table th,\r\n.summary-table td {\r\n    padding: 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #e0e0e0;\r\n}\r\n.summary-table thead,\r\n.summary-table tfoot {\r\n    position: sticky;\r\n    background: #f8f9fa;\r\n}\r\n\r\n.summary-table thead {\r\n    top: 0;\r\n}\r\n\r\n.summary-table tfoot {\r\n    bottom: 0;\r\n}\r\n.summary-table tbody {\r\n    display: block;\r\n    max-height: 220px; /* adjust to desired viewport space */\r\n    overflow-y: auto;\r\n}\r\n.summary-table thead,\r\n.summary-table tfoot,\r\n.summary-table tbody tr {\r\n    display: table;\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n.summary-table tbody {\r\n    width: 100%;\r\n}\r\n\r\n.summary-table th,\r\n.summary-table td {\r\n    box-sizing: border-box;\r\n}\r\n.summary-table th {\r\n    background-color: #f8f9fa;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.summary-table .total-row {\r\n    background-color: #e3f2fd;\r\n    font-weight: 500;\r\n}\r\n\r\n.brand-content {\r\n    padding: 40px;\r\n    text-align: center;\r\n    color: #666;\r\n}\r\n\r\n.custom-tooltip {\r\n    background: white;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    font-size: 12px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.tooltip-label {\r\n    font-weight: 600;\r\n    margin-bottom: 5px;\r\n    color: #333;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n    .launches-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .app-launches {\r\n        padding: 15px;\r\n    }\r\n\r\n    .section-tabs {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .chart-container {\r\n        height: 250px;\r\n    }\r\n}\r\n\r\n.average-stats{\r\n    border-radius: 8px;\r\n    overflow-y: auto;\r\n    max-height: 460px;\r\n}\r\n.average-length{\r\n    max-height:  375px !important;\r\n}\r\n.customer-header{\r\n    background-color: #f8f9fa;\r\n    font-weight: 600;\r\n    color: #333;\r\n    padding: 5px;\r\n    font-size: 14px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
